import api from "../api";

const doctorTeleConsultationApi = {
  getConsultations: async () => {
    const response = await api.get(
      "/doctor/tele-consultations/"
    );

    return response.data;
  },

  getConsultation: async (consultationId) => {
    const response = await api.get(
      `/doctor/tele-consultations/${consultationId}/`
    );

    return response.data;
  },

  startConsultation: async (consultationId) => {
    const response = await api.post(
      `/doctor/tele-consultations/${consultationId}/start/`
    );

    return response.data;
  },

  endConsultation: async (consultationId) => {
    const response = await api.post(
      `/doctor/tele-consultations/${consultationId}/end/`
    );

    return response.data;
  },
  getDoctorForm: async (consultationId) => {
      const response = await api.get(
          `/teleconsultations/${consultationId}/doctor-form/`
      );
      return response.data;
  },

  saveDoctorForm: async (consultationId, payload) => {
      const response = await api.post(
          `/teleconsultations/${consultationId}/doctor-form/`,
          payload
      );
      return response.data;
  },
  
  getFamilyMemberTestResults: async (memberId) => {
    const response = await api.get(
      `/family-members/${memberId}/test-results/`
    );

    return response.data;
  },

  getUnderwritingAssessment: async (memberIdentifier) => {
    const response = await api.get(
      `/underwriting/family-members/${encodeURIComponent(memberIdentifier)}/`
    );

    return response.data;
  },
};

export default doctorTeleConsultationApi;